import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { useContext, useState } from 'react';

import { ConfigContext } from '@/Contexts/ConfigContext';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { ProgramApiResponse, ProgramNames } from '@/models/Program';

function SelectProgram({
  includeNoValueSelection = false,
  includeClearSelectionButton = false,
  availableProgramOptionIds = null,
  onChange,
}: {
  includeNoValueSelection?: boolean;
  includeClearSelectionButton?: boolean;
  availableProgramOptionIds?: ProgramNames[] | null;
  onChange?: (event: SelectChangeEvent) => void;
}) {
  const { allPrograms } = useContext(ConfigContext);
  const { translatedText } = useContext(LocaleContext);

  const [selectedProgramId, updateSelectedProgramId] = useState<ProgramNames | null>(null);

  function handleClearClick() {
    updateSelectedProgramId(null);
    handleChange({ target: { value: '' } } as SelectChangeEvent);
  }

  return (
    <Box sx={{ minWidth: 170, width: 'auto', alignSelf: 'center' }}>
      <FormControl fullWidth>
        <InputLabel
          id='program-select-label'
          sx={{ whiteSpace: 'nowrap', maxWidth: 'none', overflow: 'visible' }}
        >
          {translatedText.signup.selectProgram}
        </InputLabel>
        <Select
          labelId='program-select-label'
          id='program-select'
          value={
            selectedProgramId != null && allPrograms != null ? selectedProgramId.toString() : ''
          }
          label={translatedText.signup.selectProgram}
          onChange={handleChange}
          endAdornment={
            includeClearSelectionButton && (
              <IconButton
                onClick={handleClearClick}
                sx={{ display: selectedProgramId != null ? '' : 'none' }}
              >
                <ClearIcon />
              </IconButton>
            )
          }
          sx={{
            '& .MuiSelect-iconOutlined': {
              display: selectedProgramId != null && includeClearSelectionButton ? 'none' : '',
            },
          }}
        >
          {includeNoValueSelection && (
            <MenuItem value=''>
              <em>{translatedText.signup.selectProgram}</em>
            </MenuItem>
          )}
          {allPrograms != null ? (
            allPrograms?.map((program: ProgramApiResponse) => {
              if (
                availableProgramOptionIds != null &&
                !availableProgramOptionIds.includes(program.id)
              ) {
                return null;
              }
              return (
                <MenuItem key={program.id} value={program.id}>
                  {program.programName}
                </MenuItem>
              );
            })
          ) : (
            <Box />
          )}
        </Select>
      </FormControl>
    </Box>
  );

  function handleChange(event: SelectChangeEvent) {
    updateSelectedProgramId(Number(event.target.value));

    if (onChange != null) onChange(event);
  }
}

export default SelectProgram;
